import React from 'react';
import { useWizard } from 'react-use-wizard';
import ProjectInformation from "../../../components/Project/ProjectInformation";
import ProjectFilters from "../../../components/Project/ProjectFilters";
import WizardProgress from "./WizardProgress";
import WizardStepWrapper from "./WizardStepWrapper";
import { withTranslation } from 'react-i18next';

const ProjectStep1 = (props) => {
    const { nextStep } = useWizard();
    const { t, stepLabels } = props;

    const isValid =
        typeof props.projectName === "string" && props.projectName.trim() !== "" &&
        isValidNumber(props.annualFTECost?.value) &&
        isValidNumber(props.annualFTEHours?.value) &&
        isValidNumber(props.LTNonError?.value) &&
        isValidNumber(props.LTSysError?.value) &&
        isValidNumber(props.LTUserError?.value) &&
        isValidNumber(props.LTUncatMessage?.value) &&
        isValidNumber(props.projectDuration?.value) &&
        isValidNumber(props.projectUser?.value) &&
        isValidNumber(props.testEffortPerModule?.value);

    function isValidNumber(val) {
        const num = Number(val);
        return val !== undefined && val !== "" && !isNaN(num);
    }

    return (
        <WizardStepWrapper>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-11 col-lg-10">
                        <WizardProgress labels={stepLabels} />

                        <h5 className="text-center wizard-subtitle">{t('project:infoTitle')}</h5>

                        <ProjectInformation {...props} trans={t} />
                        <ProjectFilters {...props} trans={t} />

                        <div className="wizard-nav-buttons text-center mt-4">
                            <button
                                className="btn btn-primary"
                                onClick={nextStep}
                                disabled={!isValid}
                            >
                                {t('common:next')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </WizardStepWrapper>
    );
};

export default withTranslation()(ProjectStep1);